/* eslint-disable camelcase */
import React, {
    useContext, useEffect, useMemo, useState,
} from 'react';
import { useReactiveVar } from '@apollo/client';
import { isReferralPopupOpenVar } from 'app/apollo/reaction';
import { abTestDataContext, AFTER_FIVE_ORDERS_TEST } from 'app/containers/contexts/abTest.context';
import { analyticService } from 'global/services';
import { useRefferalUserState } from './useRefferalUserState';

export const usePopupOpeningState = () => {
    const { isOpen: isInviteFriedPopupOpen, ctx } = useReactiveVar(isReferralPopupOpenVar);
    const { referral_after_five_orders } = useContext(abTestDataContext);
    const { location: { pathname } } = window;

    const setInviteFriedPopupOpen = (isOpen) => {
        isReferralPopupOpenVar({ isOpen: isOpen(isOpen), ctx });
    };

    const isPopupShownSesstionData = sessionStorage.getItem('isPopupShown');
    const [isPopupShown, setIsPopupShown] = useState(isPopupShownSesstionData);
    const { canShareReferralLink, user_ID } = useRefferalUserState();


    const isUserInTest = useMemo(
        () => referral_after_five_orders === AFTER_FIVE_ORDERS_TEST,
        [referral_after_five_orders],
    );

    // main, profile, menu
    const posiblePathnames = useMemo(() => {
        if (pathname === '/') {
            return true;
        }
        const match = pathname.match(/\/(profile|menu)(?=\/|$)/);
        return match ? match[1] : false;
    }, [pathname]);

    const isToNeedRenderPopup = useMemo(
        () => (!isPopupShown && canShareReferralLink && isUserInTest && posiblePathnames),
        [isPopupShown, canShareReferralLink, isUserInTest, posiblePathnames],
    );

    useEffect(() => {
        if (isToNeedRenderPopup) {
            sessionStorage.setItem('isPopupShown', window.location.pathname);
            isReferralPopupOpenVar({ isOpen: true, ctx: 'after_five' });
            analyticService.push({
                eventName: 'After_five_orders_show_referral_pop_up',
            });
            setIsPopupShown(true);
        }
    }, [isToNeedRenderPopup]);

    return [isInviteFriedPopupOpen, setInviteFriedPopupOpen, user_ID];
};
